<template>
  <div v-if="!isError">
    <dashboard-template>
      <template slot="dashboard-header">
        <div class="dashboard-content">
          <div class="d-flex mb-2">
            <h6 class="mb-1">{{ $route.meta.heading }} <span v-if="createdFeed.name !== ''">- {{ createdFeed.name }}</span></h6>
            <img v-if="createdFeed.type !== null && createdFeed.type !== undefined" :src="createdFeed.type.imageUrl" class="ml-4" height="22" width="22" />
          </div>
        </div>
      </template>
      <template slot="dashboard-body">
        <div class="dashboard-content feed-menu-container">
          <div class="feed-navbar feed-navbar-create">
            <span v-bind:class="{ active: this.$route.name === 'feed.create.main-settings' }">{{ $t('feeds.main_settings') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.create.field-mapping' }">{{ $t('feeds.field_mapping') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.create.rules' }">{{ $t('feeds.rules') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.create.filters' }">{{ $t('feeds.filters') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.create.tagging' }">{{ $t('feeds.tagging') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.create.preview' }">{{ $t('global.preview') }}</span>
          </div>
          <div class="d-flex">
            <button type="button" class="btn btn-small-medium btn-orange-dark mr-4" @click="saveDraft">
              <save-icon></save-icon>
              <span>{{ $t('feeds.save_draft') }}</span>
            </button>
            <button type="button" class="btn btn-small-medium btn-danger" @click="removeDraft">
              <trash-2-icon></trash-2-icon>
              <span>{{ $t('feeds.delete_draft') }}</span>
            </button>
          </div>
        </div>
        <router-view :key="$route.path" :feed="createdFeed" :products="$attrs.project.products" :project="$attrs.project"></router-view>
      </template>
    </dashboard-template>
  </div>
  <div v-else>
    <dashboard-template>
      <template slot="dashboard-body">
        <div class="dashboard-content p-5">
          <div class="alert alert-danger mb-5 d-flex align-items-center" role="alert">
            <img width="40" height="40" src="/app/images/icons/warning_danger.svg" class="mr-4" />
            <p class="mb-0">{{ $t('feeds.no_feed_draft_found') }}</p>
          </div>
          <router-link :to="{ name: 'feed.create.main-settings', params: { projectId: $attrs.projectId, feed: createdFeed }}" class="mr-2">
            <button type="button" class="btn btn-large btn-orange-dark">
              <plus-circle-icon></plus-circle-icon>
              <span>{{ $t('feeds.add_new_feed') }}</span>
            </button>
          </router-link>
        </div>
      </template>
    </dashboard-template>
  </div>
</template>

<script>
import DashboardTemplate from '@/views/Dashboard'
import { PlusCircleIcon, SaveIcon, Trash2Icon } from 'vue-feather-icons'

export default {
  name: 'FeedCreate',

  data () {
    return {
      createdFeed: {},
      isError: false
    }
  },

  props: {
    feed: { required: false, type: Object }
  },

  created () {
    if (localStorage.getItem('feed') !== null) this.createdFeed = JSON.parse(localStorage.getItem('feed'))
    else if (this.feed === undefined) {
      if (this.$route.name === 'feed.create.main-settings') {
        this.createdFeed = { name: '' }
      } else {
        this.isError = true
      }
    } else {
      this.createdFeed = this.feed
    }
  },

  methods: {
    saveDraft () {
      const parsed = JSON.stringify(this.createdFeed)
      localStorage.setItem('feed', parsed)
      this.$bvToast.toast(this.$t('feeds.feed_draft_save_description'), {
        autoHideDelay: 3000,
        solid: true,
        title: this.$t('feeds.feed_draft_save'),
        variant: 'success'
      })
    },

    removeDraft () {
      localStorage.removeItem('feed')
      this.$bvToast.toast(this.$t('feeds.feed_draft_delete_description'), {
        autoHideDelay: 3000,
        solid: true,
        title: this.$t('feeds.feed_draft_delete'),
        variant: 'success'
      })
    }
  },

  components: { DashboardTemplate, PlusCircleIcon, SaveIcon, Trash2Icon }
}
</script>
